import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import {
  TitleWrapper,
  Title,
  TitleAndUpdatedAt,
  ActionGroup,
  HeaderLabel,
  SelectBox,
  SelectExecute,
} from './styles/TitleAreaStyles';
import AppButton from '../../styles/common/AppButton';
import { convertISOFormatToDate } from '../../lib/tools';
import existsStatusDuringSaving from './functions/existsStatusDuringSaving';

// 報告書のステータス
export const ReportStatus = {
  create: 'create',
  published: 'published',
  complete: 'complete',
};

/**
 * Web報告書作成・編集画面のタイトルバーエリアのページコンポーネント
 * @component
 */
const TitleArea = ({
  lastUpdatedAt,
  reportStatus,
  reportStatusSelections,
  onClickBack,
  onClickPreview,
  onChangeReportStatus,
  onClickChange,
  isStatusUpdateButtonDisabled,
  isAutoSaving,
}) => {
  const intl = useIntl();
  const { formatMessage } = intl;

  // 最終更新日
  const dateTime = convertISOFormatToDate(lastUpdatedAt);
  const lastUpdatedLabel =
    (dateTime &&
      formatMessage(
        { id: 'report.edit.header.lastModifiedDate' },
        { dateTime },
      )) ||
    '';

  return (
    <TitleWrapper>
      <TitleAndUpdatedAt>
        <Title>
          <FormattedMessage id="report.edit.header.title" />
        </Title>
        <HeaderLabel>{lastUpdatedLabel}</HeaderLabel>
      </TitleAndUpdatedAt>
      <ActionGroup>
        <AppButton
          className="button"
          small
          bgColor="white"
          color="black"
          width="80"
          onClick={onClickBack}
        >
          <FormattedMessage id="report.edit.action.return" />
        </AppButton>
        <AppButton
          className="button"
          small
          width="80"
          onClick={onClickPreview}
          disabled={existsStatusDuringSaving(isAutoSaving)}
        >
          <FormattedMessage id="report.edit.action.preview" />
        </AppButton>
        <HeaderLabel>
          <FormattedMessage id="report.edit.header.status" />
        </HeaderLabel>
        <SelectBox>
          <SelectExecute
            name="reportStatus"
            id="report-status-select"
            className="selected"
            value={reportStatus}
            onChange={e => onChangeReportStatus(e.target.value)}
          >
            {reportStatusSelections &&
              reportStatusSelections.map(selection => {
                const key = `select-${selection.value}`;
                return (
                  <option key={key} value={selection.value}>
                    {selection.text}
                  </option>
                );
              })}
          </SelectExecute>
        </SelectBox>
        <AppButton
          className="button"
          small
          width="50"
          onClick={onClickChange}
          disabled={
            isStatusUpdateButtonDisabled ||
            existsStatusDuringSaving(isAutoSaving)
          }
        >
          <FormattedMessage id="report.edit.action.statusChange" />
        </AppButton>
      </ActionGroup>
    </TitleWrapper>
  );
};

TitleArea.propTypes = {
  lastUpdatedAt: PropTypes.string.isRequired,
  reportStatus: PropTypes.string.isRequired,
  reportStatusSelections: PropTypes.array.isRequired,
  onClickBack: PropTypes.func.isRequired,
  onClickPreview: PropTypes.func.isRequired,
  onChangeReportStatus: PropTypes.func.isRequired,
  onClickChange: PropTypes.func.isRequired,
  isStatusUpdateButtonDisabled: PropTypes.bool.isRequired,
  isAutoSaving: PropTypes.bool.isRequired,
};

export default TitleArea;
